import React, { FunctionComponent } from 'react';
import { IBindingCallback1 } from '../../../../common/models/callback';
import RatingScaleQuestion from '../RatingScaleQuestion';
import FreeResponseQuestion from '../FreeResponseQuestion';
import VerificationQuestion from '../VerificationQuestion';
import { IQuestionForReference } from '../../../../common/models/question/IQuestionForReference';
import { QuestionOption } from '../../../../common/enums/QuestionOption';
import { includes } from 'ramda';

interface IQuestionProps {
  isPreview: boolean;
  question: IQuestionForReference;
  candidateFirstName: string;
  onAnswer: IBindingCallback1<IQuestionForReference>;
}

const Question: FunctionComponent<IQuestionProps> = ({ question, isPreview, candidateFirstName, onAnswer }) => {
  const RenderQuestion = () => {
    if (includes(QuestionOption.Yes, question.options)) {
      return (
        <VerificationQuestion
          candidateName={candidateFirstName}
          isPreview={isPreview}
          question={question}
          onAnswer={onAnswer}
        />
      );
    }
    if (includes(QuestionOption.AlmostAlways, question.options)) {
      return <RatingScaleQuestion question={question} onAnswer={onAnswer} candidateFirstName={candidateFirstName} />;
    }
    return (
      <FreeResponseQuestion
        isPreview={isPreview}
        question={question}
        onAnswer={ans => onAnswer(ans as IQuestionForReference)}
        candidateFirstName={candidateFirstName}
      />
    );
  };

  return <RenderQuestion />;
};

export default Question;
